import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h2 className="mb-5">指定したページが見つかりませんでした</h2>
      <p>ページが移動または削除されたか、URLの入力間違いの可能性があります。正しいURLをご指定いただくか、上記ナビゲーションメニューからご覧になりたい情報をお探しください。</p>
    </div>
  );
};

export default NotFound;